<template>
  <div class="album-profile-wrapper">
    <div class="container">
      <button v-if="!showAddAlbum" class="button-primary mb-10" @click="showAddAlbumBox">New Album</button>
      <button v-else class="button-secondary mb-10" @click="hideAddAlbumBox">
        <span>
          Cancel
        </span>
      </button>
      <div class="albumprofile-page-container">
        <div class="albumprofile-main-content">
          <div class="card w-100">
            <h3>My Albums</h3>
            <div class="album-display">
              <AddAlbumBox v-if="showAddAlbum"/>
              <AlbumBox v-for="album in albums" :album_name="album.name" :id="album.id"/>
              <div v-if="albums.length == 0 && !showAddAlbum" class="no-albums-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     class="bi bi-images" viewBox="0 0 16 16">
                  <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
                  <path
                      d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z"/>
                </svg>
                <p>No albums found. Create one!</p>
              </div>
            </div>
          </div>
        </div>
        <div class="albumprofile-sidebar">
          <div class="card w-100">
            <h3>Stats</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import AddAlbumBox from '../common/AddAlbumBox.vue';
import AlbumBox from '../common/AlbumBox.vue';
import apiService from '@/services/apiService';

const albums = ref([]);
const showAddAlbum = ref(false);

function showAddAlbumBox() {
  showAddAlbum.value = true;
}

function hideAddAlbumBox() {
  showAddAlbum.value = false;
}

onMounted(async () => {
  const result = await apiService.getAlbums();
  albums.value = result;

})

</script>

<style scoped>
.album-profile-wrapper {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  color: #323232;
}

.albumprofile-page-container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: start;
  justify-content: start;
}

.albumprofile-main-content {
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-right: 1rem;
}

.albumprofile-sidebar {
  width: 30%;
}

.album-display {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.no-albums-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: gray;
  width: 100%;
}
</style>